import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      position: 'relative'
    },
    loadingBackground: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255,255,255, 0.5)',
      zIndex: 3
    }
  })
);

export const SuspenseWrapper: React.FC = ({ children }) => {
  const classes = useStyles();

  const fallback = (
    <div className={classes.loadingBackground}>
      <CircularProgress />
    </div>
  );

  return <React.Suspense fallback={fallback}>{children}</React.Suspense>;
};
